import { Box, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';

interface WrapperProps {
  children: ReactNode;
  sxProps?: SxProps<Theme>;
}

export const Wrapper = ({ sxProps, children }: WrapperProps) => {
  return (
    <Box
      sx={{
        minWidth: 'fit-content',
        minHeight: 'fit-content',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        ...sxProps,
      }}
    >
      {children}
    </Box>
  );
};
